import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Delete {packageName}',
    id: 'obv+0B',
    description: 'Delete modal title',
  },
  description: {
    defaultMessage: "Are you sure you want to delete {packageName}? This can't be undone.",
    id: 'QrdCKS',
    description: 'Delete modal message',
  },
  'delete-button': {
    defaultMessage: 'Delete',
    id: 'KhmgSB',
    description: 'Delete modal delete button label',
  },
  'deleting-button': {
    defaultMessage: 'Deleting...',
    id: 'dT+rwR',
    description: 'Delete modal deleting button label',
  },
});
